import script from "./FeedbackView.vue?vue&type=script&setup=true&lang=js"
export * from "./FeedbackView.vue?vue&type=script&setup=true&lang=js"

import "./FeedbackView.vue?vue&type=style&index=0&id=6af43d34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6af43d34"]])

export default __exports__